import React from "react";
import { motion } from "framer-motion";
import {
  Code2,
  Globe,
  Layers,
  Atom,
  FileCode,
  Cloud,
  Cpu,
  Wrench,
  Server,
  Database,
  GitPullRequest,
  CheckCircle2
} from "lucide-react";
import { SERVICES } from "../data/portfolioData";

const ICON_MAP = {
  Code2,
  Globe,
  Layers,
  Atom,
  FileCode,
  Cloud,
  Cpu,
  Wrench,
  Server,
  Database,
  GitPullRequest
};

export default function Services() {
  return (
    <section id="services" className="py-20 relative overflow-hidden bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto space-y-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-indigo-100 border border-indigo-200 text-indigo-900 font-mono text-xs font-bold shadow-sm"
          >
            <Code2 size={15} /> ENGINEERING SERVICES & EXPERTISE
          </motion.div>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-3xl sm:text-4xl font-black tracking-tight text-slate-900"
          >
            Comprehensive <span className="gradient-text-indigo">Software & Cloud</span> Solutions
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-slate-700 text-base sm:text-lg font-medium leading-relaxed"
          >
            End-to-end capabilities spanning full-stack application development, enterprise CMS systems, database architecture, cloud infrastructure, and deployment automation.
          </motion.p>
        </div>

        {/* Services Grid */}
        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((service, i) => {
            const IconComponent = ICON_MAP[service.icon] || Code2;

            return (
              <motion.div
                key={service.title}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="group relative p-8 rounded-3xl bg-white border border-slate-200 hover:border-indigo-500 transition-all duration-300 hover:-translate-y-1.5 shadow-sm hover:shadow-md flex flex-col justify-between"
              >
                <div className="space-y-4">
                  <div className="w-12 h-12 rounded-2xl bg-indigo-50 border border-indigo-200 flex items-center justify-center text-indigo-700 group-hover:scale-110 group-hover:bg-indigo-600 group-hover:text-white transition-all duration-300 shadow-sm">
                    <IconComponent size={24} />
                  </div>

                  <h3 className="text-xl font-bold text-slate-900 group-hover:text-indigo-700 transition-colors">
                    {service.title}
                  </h3>

                  <p className="text-sm text-slate-700 font-normal leading-relaxed">
                    {service.desc}
                  </p>
                </div>

                <div className="pt-6 mt-6 border-t border-slate-100 flex items-center gap-2 text-xs font-mono font-bold text-indigo-700">
                  <CheckCircle2 size={15} className="text-emerald-600 shrink-0" />
                  <span>Production Ready Solutions</span>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
